<script lang="ts" setup>

import SectionHeadline from '@/components/SectionHeadline.vue'
import SaleSetCard from '@/components/steps/sale-set/SaleSetCard.vue'
import { computed } from 'vue'
import projectStore from '@/store/ProjectStore.ts'
import { Article } from '@/services/models/Article.ts'
import formStore from '@/store/FormStore.ts'
import { StepsController } from '@/controllers/StepsController.ts'
import userStore from '@/store/UserStore.ts'
import { SalesPackageType } from '@/helper/Types.ts'

const suggestedSalesPackages = computed((): Article[] => {
  return projectStore.salePackages as Article[]
})

function isSaleSetSelected(salePackage: Article): boolean {
  return salePackage.id === formStore.data.salePackageId
}

function selectSalePackage(salePackage: Article): void {
  if (isSaleSetSelected(salePackage)) {
    return
  }

  formStore.data.salePackageId = salePackage.id

  StepsController.currentStepValid()
}

function validate(): boolean {
  if (userStore.enableBundleSelection && projectStore.projectProperties.salePackage.val === SalesPackageType.BUNDLE) {
    return true
  }
  return !!formStore.data.salePackageId
}

defineExpose({
  validate
})
</script>

<template>
  <div class="steps__content" data-hj-whitelist>
    <div class="steps-table__header">
      <SectionHeadline
        :translation-key="projectStore.salePackage === SalesPackageType.SALES_PACKAGE ? 'step_sale_set.title': 'step_sale_set.bundle_title'" />
    </div>
    <p v-if="projectStore.salePackage === SalesPackageType.SALES_PACKAGE">
      {{ $t('step_sale_set.amount_info') }}
      ({{ suggestedSalesPackages.length }})
    </p>
    <p v-else>
      {{ $t('step_sale_set.bundle_info') }}
    </p>
    <div class="sale-set-list">
      <SaleSetCard
        v-for="(salePackage,index) in suggestedSalesPackages"
        :key="`${salePackage.id}`"
        :sale-package="salePackage"
        :sale-package-number="index + 1"
        :is-selected="isSaleSetSelected(salePackage)"
        @on-select-sale-package="selectSalePackage(salePackage)"
      />
    </div>
    <div class="container" />
  </div>
</template>

<style lang="scss">

.sale-set-list {
  display: grid;
  grid-template-columns: 1fr;
  gap: 2rem;
  margin-top: 2rem;
}
</style>
